import gql from "graphql-tag";

export const GET_SECURITY_PROFILE = gql`
    query GetSecurityProfile {
        securityProfile {
            userId
            displayName
            firstName
            lastName
            email
            roles
            orgScopes
        }
    }
`;

export const GET_SECURITY_ROLES = gql`
  query GetSecurityRoles {
    securityRoles {
      id: userRoleTypeId
      name: roleName
      desc: roleDescr
      scopeRole
      adminRole
      dependRole
    }
  }
`;

export const LOGOUT = gql`
    mutation Logout {
        logout
    }
`;
